import {
  SET_ALL_QUESTIONARIELIST_LIST,
  SET_ALL_QUESTION_BANK_LIST,
  SET_APPLICANT_CANDIDATE_LIST,
  SET_APPLIED_CANDIDATES_LIST,
  SET_APPLIED_CANDIDATES_LIST_TRUE,
  SET_APPLIED_COLLEGES_LIST,
  SET_CANDIDATE_DETAILS,
  SET_CITIES_LIST,
  SET_COLLEGE_BASED_ON_ATS,
  SET_COLLEGE_BASED_ON_QB,
  SET_CORPORATE_METRICS_DATA,
  SET_CURRENT_JOB_ID,
  SET_DEGREES_BASED_EX_ROLES,
  SET_DEGREES_BASED_ON_ATS,
  SET_DEGREES_BASED_ON_ROLES,
  SET_DEGREE_BASED_ON_QB,
  SET_DESIGNATION_LIST,
  SET_DRAFT_DATA,
  SET_DRIVE_CREATED_CANDIDATE,
  SET_DRIVE_CREATED_CANDIDATE_PREVIEW,
  SET_DRIVE_DATA,
  SET_DRIVE_LIST,
  SET_DRIVE_NOT_CREATED_CANDIDATE,
  SET_DRIVE_ROLE_METRICS,
  SET_EDITING_ROLE,
  SET_EDIT_ROLE_ON_VIEW,
  SET_ELASTIC_SEARCH_DEGREE_DATA,
  SET_EVALUATION_DATA,
  SET_FUNCTIONS_LIST,
  SET_INDUSTRIES_LIST,
  SET_INSTITUTES_LIST,
  SET_INSTITUTES_LOCATION_LIST,
  SET_INSTITUTE_CAMPUS_DETAILS,
  SET_JOBS_LIST,
  SET_JOB_ROLE_CAMPUS_LIST,
  SET_LIST_OF_DEGREE,
  SET_LIST_OF_LOCATION,
  SET_LOCATION_BASED_ON_ATS,
  SET_PREVIEW_ROLE_DATA,
  SET_PROMOTION_DATA,
  SET_QUESTIONNAIRE_DATA,
  SET_QUESTIONNIER_CANDIDATE_LIST,
  SET_RANKING_CONFIG_DATA,
  SET_RESCHEDULE_LIST,
  SET_ROLES_ROUNDS,
  SET_ROLE_APPLIED_DRIVE_METRICS,
  SET_ROLE_CITY,
  SET_ROLE_DATA_TO_EXCEL,
  SET_ROLE_VIEW_CARD,
  SET_ROLE_VIEW_CARD_ATS,
  SET_ROLE_VIEW_CHART,
  SET_SINGLE_QUESTIONARIE,
  SET_SINGLE_ROLE_DATA,
  SET_SKILLS_LIST,
  SET_SPECIALISATION_LIST,
  SET_STDALGO_DATA,
  SET_ROLE_DETAILS,
  SET_YEAR_OF_PASSING,
} from 'modules/Roles/actions'

import {
  SET_INDIVIDUAL_DRAWER,
  SET_QUESTIONAIRE_GRAPHLIST,
  SET_QUESTION_AND_ANSWER,
} from '../Roles/ViewRole/Header/QuestionaireDashboard/actions'


const initialState = {
  questionAndAnswer: [],
  corporateMetrics: {},
  jobsList: {},
  previewRoleData: {},
  currentJobId: '',
  institutesList: [],
  singleRoleData: {},
  roleDetails: {},
  isEditingRole: false,
  driveData: {
    shortListCand: 500,
  },
  appliedCollegesList: {},
  appliedCandidatesList: {},
  applicantCandidateList: {},
  questionaireDBList: {},
  appliedCandidatesListTrue: {},
  listOfDegree: {},
  listOfSkills: {},
  rankingConfigData: [],
  listOfCities: [],
  instituteCampusDetails: {},
  driveList: {},
  courseData : {},
  driveRoleMetrics: [],
  designationList: {},
  functionsList: {},
  isEditRoleOnView: false,
  candidateDetails: {},
  roleAppliedDriveMetrics: {},
  industriesList: {},
  specialisationList: [],
  jobRoleCampusList: {},
  degreesListBasedOnRoles: [],
  degreesListBasedExRoles: [],
  degreesListBasedOnATS: [],
  collegeListBasedOnATS: [],
  collegeListBasedOnQB: [],
  degreeListBasedOnQB: [],
  locationListBasedOnATS: [],
  DriveNotCreatedCandidates: {},
  DriveCreatedCandidates: {},
  DriveCreatedCandidatesPreview: {},
  roleViewCardData: {},
  roleViewCardDataATS: {},
  roleViewChartData: {},
  reShecduleList: [],
  roleRoundList: [],
  allQuestionarieList: [],
  singleQuestion: [],
  allQuestionBankList: [],
  institutesLocationList: {},
  roleDataToExcel: [],
  roleCityData: [],
  roleDraftData: [],
  graphList: [],
  promotionData: [],
  evaluationData: {},
  questionnaireData: {},
  studentRankingData: [],
  elasticSearchDegreeData: [],
  individualDrawerQuestion: [],
  locationList: [],
  yearOfPassing: [],
}
export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROLE_CITY:
      return {
        ...state,
        roleCityData: action.data,
      }
    case SET_ROLE_DETAILS:
      return {
        ...state,
        roleDetails: action.obj,
      }
  
    case SET_LIST_OF_LOCATION:
      return {
        ...state,
        locationList: action.data,
      }
    case SET_QUESTION_AND_ANSWER:
      return {
        ...state,
        questionAndAnswer: action.data,
      }
    case SET_YEAR_OF_PASSING:
      return {
        ...state,
        yearOfPassing: action.data,
      }
    case SET_ELASTIC_SEARCH_DEGREE_DATA:
      return {
        ...state,
        elasticSearchDegreeData: action.data,
      }
    case SET_DRAFT_DATA:
      return {
        ...state,
        roleDraftData: action.data,
      }
    case SET_ROLE_DATA_TO_EXCEL:
      return {
        ...state,
        roleDataToExcel: action.data,
      }

    case SET_QUESTIONAIRE_GRAPHLIST:
      return {
        ...state,
        graphList: action.data,
      }
    case SET_INDIVIDUAL_DRAWER:
      return {
        ...state,
        individualDrawerQuestion: action.data,
      }

    case SET_RESCHEDULE_LIST:
      return {
        ...state,
        reShecduleList: action.data,
      }

    case SET_ROLES_ROUNDS:
      return {
        ...state,
        roleRoundList: action.data,
      }
    case SET_CORPORATE_METRICS_DATA:
      return {
        ...state,
        corporateMetrics: action.data,
      }
    case SET_JOBS_LIST:
      return {
        ...state,
        jobsList: action.data,
      }
    case SET_PROMOTION_DATA:
      return {
        ...state,
        promotionData: action?.data,
      }
    case SET_EVALUATION_DATA:
      return {
        ...state,
        evaluationData: action?.data,
      }
    case SET_QUESTIONNAIRE_DATA:
      return {
        ...state,
        questionnaireData: action?.data,
      }
    case SET_STDALGO_DATA:
      return {
        ...state,
        studentRankingData: action?.data,
      }
    case SET_PREVIEW_ROLE_DATA:
      return {
        ...state,
        previewRoleData: action.data,
      }
    case SET_CURRENT_JOB_ID:
      return {
        ...state,
        currentJobId: action.id,
      }
    case SET_INSTITUTES_LIST:
      return {
        ...state,
        institutesList: action.obj,
      }
    case SET_INSTITUTES_LOCATION_LIST:
      return {
        ...state,
        institutesLocationList: action.obj,
      }
    case SET_SINGLE_ROLE_DATA:
      return {
        ...state,
        singleRoleData: action.obj,
      }
    case SET_EDITING_ROLE:
      return {
        ...state,
        isEditingRole: action.value,
      }
    case SET_DRIVE_DATA: {
      return {
        ...state,
        driveData: action.data,
      }
    }
    case SET_APPLIED_COLLEGES_LIST: {
      return {
        ...state,
        appliedCollegesList: action.data,
      }
    }
    case SET_APPLIED_CANDIDATES_LIST: {
      return {
        ...state,
        appliedCandidatesList: action.data,
      }
    }
    case SET_APPLIED_CANDIDATES_LIST_TRUE: {
      return {
        ...state,
        appliedCandidatesListTrue: action.data,
      }
    }
    case SET_LIST_OF_DEGREE:
      return {
        ...state,
        listOfDegree: action.value,
      }
    case SET_SKILLS_LIST:
      return {
        ...state,
        listOfSkills: action.data,
      }
    case SET_RANKING_CONFIG_DATA:
      return {
        ...state,
        rankingConfigData: action.list,
      }
    case SET_CITIES_LIST:
      return {
        ...state,
        listOfCities: action.data,
      }
    case SET_INSTITUTE_CAMPUS_DETAILS:
      return {
        ...state,
        instituteCampusDetails: action.data,
      }
    case SET_DRIVE_LIST:
      return {
        ...state,
        driveList: action.data,
      }
    case SET_DRIVE_ROLE_METRICS:
      return {
        ...state,
        driveRoleMetrics: action.data,
      }
    case SET_DESIGNATION_LIST:
      return {
        ...state,
        designationList: action.data,
      }
    case SET_FUNCTIONS_LIST:
      return {
        ...state,
        functionsList: action.data,
      }
    case SET_EDIT_ROLE_ON_VIEW:
      return {
        ...state,
        isEditRoleOnView: action.value,
      }
    case SET_CANDIDATE_DETAILS:
      return {
        ...state,
        candidateDetails: action.data,
      }
    case SET_ROLE_APPLIED_DRIVE_METRICS:
      return {
        ...state,
        roleAppliedDriveMetrics: action.data,
      }
    case SET_INDUSTRIES_LIST:
      return {
        ...state,
        industriesList: action.data,
      }
    case SET_SPECIALISATION_LIST:
      return {
        ...state,
        specialisationList: action.data,
      }
    case SET_JOB_ROLE_CAMPUS_LIST:
      return {
        ...state,
        jobRoleCampusList: action.data,
      }
    case SET_DEGREES_BASED_ON_ROLES:
      return {
        ...state,
        degreesListBasedOnRoles: action.data,
      }
    case SET_DEGREES_BASED_EX_ROLES:
      return {
        ...state,
        degreesListBasedExRoles: action.data,
      }
    case SET_DEGREES_BASED_ON_ATS:
      return {
        ...state,
        degreesListBasedOnATS: action.data,
      }
    case SET_COLLEGE_BASED_ON_QB:
      return {
        ...state,
        collegeListBasedOnQB: action.data,
      }
    case SET_DEGREE_BASED_ON_QB:
      return {
        ...state,
        degreeListBasedOnQB: action.data,
      }
    case SET_COLLEGE_BASED_ON_ATS:
      return {
        ...state,
        collegeListBasedOnATS: action.data,
      }
    case SET_LOCATION_BASED_ON_ATS:
      return {
        ...state,
        locationListBasedOnATS: action.data,
      }
    case SET_DRIVE_CREATED_CANDIDATE:
      return {
        ...state,
        DriveCreatedCandidates: action.data,
      }
    case SET_DRIVE_NOT_CREATED_CANDIDATE:
      return {
        ...state,
        DriveNotCreatedCandidates: action.data,
      }
    case SET_DRIVE_CREATED_CANDIDATE_PREVIEW:
      return {
        ...state,
        DriveCreatedCandidatesPreview: action.data,
      }
    case SET_ROLE_VIEW_CARD:
      return {
        ...state,
        roleViewCardData: action.data,
      }
    case SET_ROLE_VIEW_CARD_ATS:
      return {
        ...state,
        roleViewCardDataATS: action.data,
      }
    case SET_ROLE_VIEW_CHART:
      return {
        ...state,
        roleViewChartData: action.data,
      }
    case SET_ALL_QUESTIONARIELIST_LIST:
      return {
        ...state,
        allQuestionarieList: action.data,
      }
    case SET_ALL_QUESTION_BANK_LIST:
      return {
        ...state,
        allQuestionBankList: action.data,
      }
    case SET_SINGLE_QUESTIONARIE:
      return {
        ...state,
        singleQuestion: action.data,
      }
    case SET_APPLICANT_CANDIDATE_LIST:
      return {
        ...state,
        applicantCandidateList: action.data,
      }
    case SET_QUESTIONNIER_CANDIDATE_LIST:
      return {
        ...state,
        questionaireDBList: action.data,
      }
    default:
      return state
  }
}
